import { type Common } from './common.js';
import { type PaymentBalanceWithDetails } from './models/payment/balance.js';

export class API {
  common: Common;
  baseEndpoint = '/patient-previsit/balances';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: {
    authenticationCode: string;
    previsitFormSetId: string;
  }): Promise<PaymentBalanceWithDetails[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }
}
